import { GGTheme } from 'themes/types';

import { defaultGradient } from 'utils/gradientUtils';

const _CANVAS_LIGHT_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#000000',
  textSecondary: '#000000',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#FFFFFF',
  bgSecondary: '#FFFFFF',
  bgTertiary: '#000000',
  bgActive: '#FFCBE4',
  bgError: '#21242A',
};

const _CANVAS_DARK_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#FFF',
  textSecondary: '#000',
  textTertiary: '#9295A5',
  textActive: '#FFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#000',
  bgSecondary: '#141517',
  bgTertiary: '#FFF',
  bgActive: '#FFCBE4',
  bgError: '#21242A',
};

const _CANVAS_TOLEDO_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#FFF',
  textSecondary: '#000000',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#200013',
  bgSecondary: '#200013',
  bgTertiary: '#FFFFFF',
  bgActive: '#FFCBE4',
  bgError: '#21242A',
};

const _CANVAS_NAVY_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#FFF',
  textSecondary: '#000000',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#050117',
  bgSecondary: '#050117',
  bgTertiary: '#FFFFFF',
  bgActive: '#EABFFF',
  bgError: '#21242A',
};

const _CANVAS_BROWN_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#FFF',
  textSecondary: '#000000',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#1F0D02',
  bgSecondary: '#1F0D02',
  bgTertiary: '#FFFFFF',
  bgActive: '#EBDBBF',
  bgError: '#21242A',
};

const _CANVAS_FOREST_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#FFF',
  textSecondary: '#000000',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#FFF',
  bgSecondary: '#021B0D',
  bgTertiary: '#FFFFFF',
  bgActive: '#BFEBD3',
  bgError: '#21242A',
};

const _CANAS_DARK_OCEAN_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#FFF',
  textSecondary: '#000000',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#02031B',
  bgSecondary: '#02031B',
  bgTertiary: '#FFFFFF',
  bgActive: '#BBDEFF',
  bgError: '#21242A',
};

const _CANVAS_GREEN_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#FFF',
  textSecondary: '#000000',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#2E2B24',
  bgSecondary: '#2E2B24',
  bgTertiary: '#FFFFFF',
  bgActive: '#886176',
  bgError: '#21242A',
};

const _CANVAS_SULFUR_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#FFF',
  textSecondary: '#000000',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#1D1A18',
  bgSecondary: '#1D1A18',
  bgTertiary: '#FFFFFF',
  bgActive: '#DDF45C',
  bgError: '#21242A',
};

const _CANVAS_PURPLE_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#FFF',
  textSecondary: '#000000',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#5B0047',
  bgSecondary: '#5B0047',
  bgTertiary: '#FFFFFF',
  bgActive: '#77C0E0',
  bgError: '#21242A',
};

const _CANVAS_SAND_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#FFF',
  textSecondary: '#000000',
  textTertiary: '#FFF',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#A78A7F',
  bgSecondary: '#A78A7F',
  bgTertiary: '#FFFFFF',
  bgActive: '#342002',
  bgError: '#21242A',
};

const _CANVAS_DUNE_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#000000',
  textSecondary: '#FFFFFF',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#E7CFCD',
  bgSecondary: '#E7CFCD',
  bgTertiary: '#FFFFFF',
  bgActive: '#455E68',
  bgError: '#21242A',
};

const _CANVAS_IRON_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#000',
  textSecondary: '#FFF',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#DDDFDF',
  bgSecondary: '#DDDFDF',
  bgTertiary: '#FFFFFF',
  bgActive: '#6F4C7E',
  bgError: '#21242A',
};

const _CANVAS_PINK_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#000',
  textSecondary: '#FFF',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#FFCBE4',
  bgSecondary: '#FFCBE4',
  bgTertiary: '#FFFFFF',
  bgActive: '#200013',
  bgError: '#21242A',
};

const _CANVAS_PEAR_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#000',
  textSecondary: '#FFF',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#EBDBBF',
  bgSecondary: '#EBDBBF',
  bgTertiary: '#FFFFFF',
  bgActive: '#200013',
  bgError: '#21242A',
};

const _CANVAS_MINT_ = {
  accentSecondary: '#5A5E6D',
  accentTertiary: '#727587',
  textPrimary: '#000',
  textSecondary: '#FFF',
  textTertiary: '#9295A5',
  textActive: '#FFFFFF',
  textError: '#ff5454', // --text-error
  bgPrimary: '#BFEBD3',
  bgSecondary: '#BFEBD3',
  bgTertiary: '#FFFFFF',
  bgActive: '#021B0D',
  bgError: '#21242A',
};

const getPalette = {
  Light: _CANVAS_LIGHT_,
  Dark: _CANVAS_DARK_,
  Toledo: _CANVAS_TOLEDO_,
  Navy: _CANVAS_NAVY_,
  Brown: _CANVAS_BROWN_,
  Forest: _CANVAS_FOREST_,
  DarkOcean: _CANAS_DARK_OCEAN_,
  Green: _CANVAS_GREEN_,
  Sulfur: _CANVAS_SULFUR_,
  Purple: _CANVAS_PURPLE_,
  Sand: _CANVAS_SAND_,
  Dune: _CANVAS_DUNE_,
  Iron: _CANVAS_IRON_,
  Pink: _CANVAS_PINK_,
  Pear: _CANVAS_PEAR_,
  Mint: _CANVAS_MINT_,
};

export const getConfig = (paletteName = 'Forest'): GGTheme => ({
  token: 'canvas-theme',
  name: 'Canvas',
  palette: {
    name: 'canvas-palette',
    token: 'canvas-palette',
    accentPrimary: {
      end: {
        x: 1,
        y: 1,
      },
      start: {
        x: 0,
        y: 0,
      },
      colors: ['#FFF', '#000'],
      locations: [0, 1],
    },
    ...getPalette[paletteName as keyof typeof getPalette],
  },
  fonts: {
    token: 'canvas-fonts',
    name: 'Archivo',
    headings: [
      {
        weight: 800,
        style: 'normal',
        url: '/assets/themes/canvas/Archivo-Bold.ttf',
      },
    ],
    body: [
      {
        weight: 400,
        style: 'normal',
        url: '/assets/themes/canvas/Archivo-Medium.ttf',
      },
    ],
  },
  accentColorOverride: defaultGradient,
});
